"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingType$ = exports.ListingType$outboundSchema = exports.ListingType$inboundSchema = exports.ListingType = void 0;
const z = __importStar(require("zod"));
exports.ListingType = {
    Sale: "sale",
    Rental: "rental",
};
/** @internal */
exports.ListingType$inboundSchema = z
    .nativeEnum(exports.ListingType);
/** @internal */
exports.ListingType$outboundSchema = exports.ListingType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListingType$;
(function (ListingType$) {
    /** @deprecated use `ListingType$inboundSchema` instead. */
    ListingType$.inboundSchema = exports.ListingType$inboundSchema;
    /** @deprecated use `ListingType$outboundSchema` instead. */
    ListingType$.outboundSchema = exports.ListingType$outboundSchema;
})(ListingType$ || (exports.ListingType$ = ListingType$ = {}));
//# sourceMappingURL=listingtype.js.map